import IHomeBanner from './implements/IHomeBanner.type'

class HomeBanner implements IHomeBanner {
   Id: number
   Name: string
   Description: string
   DateCreation: Date
   constructor (id: number, name : string, description : string, dateCreation : Date) {
     this.Id = id
     this.Name = name
     this.Description = description
     this.DateCreation = dateCreation
   }
}

export default HomeBanner
